module.exports = ".prominent-form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .prominent-form atn-image-input {\n    margin-right: 20px; }\n  .prominent-form mat-form-field {\n    width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-prominent-form/product-prominent-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-prominent-form/product-prominent-form.component.scss
// module chunks = main